// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDVwzV343t8Dozc3lqhceVfAUdjHBMR49Q",
  authDomain: "ecomm-7e316.firebaseapp.com",
  projectId: "ecomm-7e316",
  storageBucket: "ecomm-7e316.firebasestorage.app",
  messagingSenderId: "899400690706",
  appId: "1:899400690706:web:a1839dc2365a411afd7ccb",
  measurementId: "G-MN0SKNYZ5N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Storage
const storage = getStorage(app);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export { storage };

export default app
